<template>
  <div class="home1">
    <div class="wrap">
      <div class="header">
        <h1 class="icon logo">
          <a
            class="wh100"
            href="javascript:;"
            @click="$router.push({ name: 'lingliu' })"
            ><span class="none">永恒岛M</span></a
          >
        </h1>
        <ul class="nav">
          <li class="">
            <a href="javascript:;" @click="$router.push({ name: 'lingliu' })"
              >官網首頁<br /><i>HOME</i></a
            >
          </li>
          <li class="">
            <a
              href="javascript:;"
              @click="$router.push({ name: 'lingliu.policy' })"
              >隱私政策<br /><i>PRIVACY POLICY</i></a
            >
          </li>
          <li class="">
            <a href="javascript:;">服務條款<br /><i>Terms Of Use</i></a>
          </li>
        </ul>
      </div>
      <div class="clearfix sectionInM">
        <div class="title">
          <a href="javascript:;" @click="$router.push({ name: 'lingliu' })"
            >首頁</a
          ><span>&gt;</span>服務條款
        </div>
        <div class="content">
          <div class="article">
            <div class="abody">
              <p class="MsoNormal" style="margin: 0cm 0cm 0pt"></p>
              <p><strong>服務條款</strong></p>

              <p>LinLuk Game 服務條款聲明:</p>

              <p>
                1.&nbsp;LinLuk&nbsp;Game遊戲平台會員(會員個人資料請於註冊頁面填寫)，以下簡稱「甲方」
              </p>
              <p>2.&nbsp;LinLuk&nbsp;Game，以下簡稱「乙方」</p>
              <p>3.&nbsp;電子郵件：developer@lingluk.com</p>
              <p>4.&nbsp;網址：lingluk.com</p>
              <p>&nbsp;</p>
              <p>
                本合約就乙方所提供的本服務（包括乙方的網站以及乙方現在正在提供和將來可能向甲方提供的網路服務和遊戲服務，以下統稱為“本服務”）所訂立的合約。
              </p>
              <p>
                如果甲方獲得並使用本服務，則應視為甲方已經詳細閲讀了本合約的內容，同意本合約的內容，並同意遵守本合約的規定。為保障甲方的權益，請於註冊使用本公司所提供的各種服務之前，仔細閲讀以下約定。一旦甲方註冊成為乙方會員，即表示甲方同意並願意遵守以下所有約定；
              </p>
              <p>&nbsp;</p>
              <p>第一條&nbsp;合約適用之範圍</p>
              <p>
                乙方提供甲方線上遊戲服務及其他相關服務（以下簡稱本服務），甲乙雙方關於本服務之權利義務，依本合約書條款之約定定之。
              </p>
              <p>
                甲方瞭解一旦甲方按下「我同意」之按鍵，即表示甲方已經詳細審閱並瞭解本合約書的所有條款達三日以上，並願意完全遵守本合約書與本遊戲相關之&nbsp;遊戲管理規章、規則。於此，提醒甲方：如果甲方是限制行為能力人（滿七歲但未滿二十歲），甲方必須取得法定代理人（如：父母、監護人）之允許始得註冊成為&nbsp;會員；若甲方為無行為能力人（未滿七歲之未成年人），則請由甲方的法定代理人代為註冊申請。甲方對本合約書之同意及其他意思表示，均視為已取得法定代理人&nbsp;之允許或符合法律行為之要件。
              </p>
              <p>
                另為促進兒童及少年身心健全發展，並保障其相關權益，甲方瞭解本平臺的遊戲最低級別屬於「遊戲軟體分級管理辦法」分類標準下之「保護級」，最高級別屬&nbsp;於「遊戲軟體分級管理辦法」分類標準下之「限制級」。一旦甲方按下「我同意」之按鍵，即表示甲方已符合相關法令對使用本級別之服務的年齡要求。
              </p>
              <p>
                甲方及其法定代理人應先檢閱本遊戲各該網站是否有保護個人資料的隱私權政策，再決定是否同意提出相關的個人資料；甲方之法定代理人並應持&nbsp;續叮嚀兒童及青少年不可洩漏自己或家人的任何資料（包括姓名、地址、電話、電子郵件信箱、照片、信用卡號等）給任何人，也不可以單獨接受網友的邀請或贈送&nbsp;禮物而與之見面。如甲方因洩露自己或家人之資料給其他第三人或與網友見面致受到任何損害或引發任何爭議，概與乙方無關。甲方及其法定代理人應謹慎選擇合適&nbsp;網站供兒童及青少年瀏覽。未滿12歲之兒童上網時，法定代理人應全程在旁陪伴，12歲以上未滿20歲之青少年上網前亦應斟酌是否給予同意。
              </p>
              <p>&nbsp;</p>
              <p>第二條&nbsp;合約之內容</p>
              <p>以下視為本合約之一部分，與本合約具有相同之效力：</p>
              <p>一、乙方有關本服務之廣告或宣傳內容。</p>
              <p>二、費率表及遊戲管理規則、規章。</p>
              <p>前項合約內容相互間有衝突者，應為消費者有利之解釋。</p>
              <p>&nbsp;</p>
              <p>第三條&nbsp;名詞定義</p>
              <p>
                一、&nbsp;線上遊戲：係指甲方透過網際網路連線經由乙方所架設之網路伺服器，使甲方得與其他不特定之多數人同時連線進行遊戲之軟體。
              </p>
              <p>
                二、&nbsp;遊戲網站：係指由乙方為提供本遊戲服務所建置之網站。
              </p>
              <p>
                三、&nbsp;遊戲點數：係指甲方依照乙方所定之付費方式所換取，作為支付甲方服務對價之單位。
              </p>
              <p>
                四、&nbsp;遊戲管理規則：係指由乙方訂立，專供為規範遊戲進行方式、會員遊戲行為守則等相關規則。
              </p>
              <p>
                五、&nbsp;遊戲歷程：係指甲方進行本遊戲時，乙方電腦系統可得提供之電磁記錄。
              </p>
              <p>
                六、&nbsp;暫停遊戲權限（凍結）：係指以限制登入遊戲網站或暫時限制遊戲帳號使用權利等方&nbsp;式，暫時禁止甲方使用本網站所提供之本服務。
              </p>
              <p>
                七、&nbsp;外掛程式：係指非由乙方提供，足以影響或改變乙方線上遊戲之運作、營運、進行方式為目的之程式，包括一切非人為操作可達成之結果。
              </p>
              <p>
                八、&nbsp;必要成本：係指乙方為履行本契約而已支出之成本或已給付予第三人之費用。
              </p>
              <p>
                九、&nbsp;永久：本合約中所涉及之永久期限，乃係以伺服器持續開啟而言，故日後一旦伺服器關閉則即為終止日，從而排除永久之適用。
              </p>
              <p>&nbsp;</p>
              <p>第四條&nbsp;服務範圍</p>
              <p>
                本合約所提供之服務，係由乙方提供網路伺服器，讓甲方透過網際網路連線登入進行本遊戲。但不包括甲方向網際網路接取服務業者申請接取網際網路之服務，及提供上網所需之各項硬體設備。
              </p>
              <p>&nbsp;</p>
              <p>第五條&nbsp;註冊資料</p>
              <p>一、提供個人註冊資料</p>
              <p>
                1.&nbsp;在申請乙方帳號時，甲方向乙方提供的是及時、詳細及準確的個人資料；
              </p>
              <p>
                2.&nbsp;所有由甲方提供的個人資料將被乙方用來作為識別甲方和其他用戶的依據；
              </p>
              <p>
                3.&nbsp;如果甲方所提供的個人註冊資料與事實不符，或已變更而未及時更新，或有任何誤導之嫌，導致乙方無法為甲方提供或進一步提供本服務，乙方將不承擔任何責任。
              </p>
              <p>二、修改註冊資料</p>
              <p>
                甲方可以在任何時候，通過乙方官方網站提供的會員服務或乙方公佈的其他途徑，更新或修改甲方申請註冊時所提供的資料。
              </p>
              <p>三、個人資料的披露</p>
              <p>
                為了向甲方提供本服務，甲方同意授權乙方以乙方認為適當的方式向第三方透露甲方的註冊資料。但是，乙方不會公開甲方的姓名、住址、通訊地址、電子郵件、帳號、密碼等個人資料。除非：
              </p>
              <p>1.&nbsp;甲方允許乙方揭露這些個人資料；</p>
              <p>2.&nbsp;有關法律法規或行政規章要求乙方揭露甲方的個人資料；</p>
              <p>
                3.&nbsp;司法機關或行政機關基於法定程序要求乙方揭露甲方的個人資料；
              </p>
              <p>
                4.&nbsp;在緊急情況下為保護其他用戶和社會大眾的人身安全，需要揭露甲方的個人資料。
              </p>
              <p>
                乙方將採取商業上合理的方式以保護甲方的個人資料的安全。乙方將使用當時科技通常可以獲得的安全技術和程序來保護甲方的個人資料不被未經授權的訪問、使用&nbsp;或洩漏。對於非因乙方提供本服務時未維護其自身電腦系統符合當時科技或專業水準可合理期待之安全性、未採取合理措施儘速回復電腦系統遭受的破壞或運作異&nbsp;常、遊戲程式漏洞、乙方的疏忽而造成甲方帳號的丟失或個人資料的洩漏，乙方不承擔任何責任。又因乙方提供本服務時未維護其自身電腦系統符合當時科技或專業&nbsp;水準可合理期待之安全性、未採取合理措施儘速回復電腦系統遭受的破壞或運作異常，或因遊戲程式漏洞致甲方受損時，乙方應依甲方之受損害情形，負損害賠償責&nbsp;任。但乙方證明其無過失者，得減輕其賠償責任。
              </p>
              <p>&nbsp;</p>
              <p>第六條&nbsp;帳號與密碼之使用及保管</p>
              <p>1.&nbsp;此處指的是甲方註冊成功的帳號及密碼。</p>
              <p>
                2.&nbsp;請瞭解帳號在註冊之後不可變更，而密碼可以通過乙方提供的服務進行修改；甲方對於甲方的帳號及密碼的保管以及使用該帳號和密碼所進行的一切行動負有完全的責任。
              </p>
              <p>
                3.&nbsp;請勿將帳號、密碼轉讓或出借給他人使用。因為甲方的保管疏忽或其他任何個人行為導致甲方的帳號或密碼遭他人非法使用及因此所衍生的任何後果，乙方不承擔任何責任。
              </p>
              <p>
                4.&nbsp;乙方應於契約終止後三十日內，保留甲方之帳號與電磁紀錄。契約非因可歸責甲方之事由而終止者，甲方於該期間內辦理續用後，有權繼續使用
              </p>
              <p>
                5.&nbsp;前項期限屆滿時，甲方仍未辦理續用，乙方得刪除該帳號及附隨於該帳號之所有資料，但法令另有規定者不在此限。
              </p>
              <p>
                6.&nbsp;任一方發現第三人非法使用甲方之帳號，或有使用安全遭異常破壞之情形時，應立即通知對方。乙方接獲甲方通知，或乙方通知甲方後，經甲方確認有前述情事，乙方得暫停該組帳號或密碼之使用權限，並更換新帳號或密碼予甲方。
              </p>
              <p>
                7.&nbsp;前項情形下，若甲方之帳號在異常期間所產生的遊戲中虛擬貨幣或虛擬物品的損失的，乙方在收到甲方返還請求并核實實際損失情況后，返還甲方相應的虛擬貨幣或虛擬物品，但可歸責於甲方者，不在此限。
              </p>
              <p>&nbsp;</p>
              <p>第七條&nbsp;帳號與密碼遭非法使用之通知與處理</p>
              <p>
                1.&nbsp;甲方如發現帳號、密碼被非法使用，且遊戲電磁紀錄遭不當移轉時，應立即通知乙方查證，經乙方以檢視IP位址是否為甲方未曾使用過之位址方式查證確認後，乙方得暫時限制相關線上遊戲使用人就本服務之使用權利。
              </p>
              <p>
                2.&nbsp;乙方應於暫時限制遊戲使用權利之時起，即刻以書面或電子郵件通知持有前項電磁紀錄之第三人提出說明。如該第三人未於接獲通知時起七日內提出說明，乙方應直&nbsp;接回復遭不當移轉之電磁紀錄予甲方，不能回復時可採其他雙方同意之相當補償方式，並於回復後解除對相關線上遊戲使用人之限制；惟乙方有提供免費安全裝置&nbsp;（如防盜卡、電話鎖等）而甲方不使用者，乙方得直接回復遭不當移轉之電磁紀錄予甲方。
              </p>
              <p>
                3.&nbsp;持有第一項電磁紀錄之第三人不同意乙方前項之處理，乙方得依報案程序，循司法途徑處理。
              </p>
              <p>
                4.&nbsp;乙方依第一項規定限制甲方之使用權時，在限制使用期間內，乙方不得向甲方收取費用。
              </p>
              <p>
                5.&nbsp;甲方如有申告不實之情形致生乙方或其他線上遊戲使用人權利受損時，應負一切法律責任。
              </p>
              <p>&nbsp;</p>
              <p>第八條&nbsp;甲方的權利</p>
              <p>
                1.&nbsp;甲方可以根據本合約以及乙方不時更新和公佈的其他規則使用本服務。
              </p>
              <p>
                2.&nbsp;甲方有權在使用本服務期間隨時向乙方提出與本服務有關的意見、建議及申訴，乙方應於接獲申訴後15日內回覆處理之結果，並應於遊戲網站上標明24小時服務與申訴之專線或電子郵件地址。
              </p>
              <p>
                3.&nbsp;如果甲方不同意本合約條款，或對乙方後來更新的條款有異議，或對本服務不滿意，甲方可以選擇停止使用本服務。如果甲方選擇停止使用本服務、則乙方即不再對甲方承擔任何義務和責任。
              </p>
              <p>
                4.&nbsp;甲方得於開始遊戲後7日內，以電子郵件或書面告知乙方解除本合約，甲方無需說明理由及負擔任何費用，並得就未使用之儲值向乙方請求退費。
              </p>
              <p>
                5.&nbsp;乙方應保存甲方之個人基本遊戲歷程紀錄（包括儲值記錄、登入/註銷IP、登入/註銷時間、物品獲取/消耗記錄、遊戲幣獲取/消耗記錄、遊戲進度記&nbsp;錄、交易記錄）以供甲方查詢，保存期間為30&nbsp;日。甲方得以書面或網路至乙方服務中心申請調閲個人遊戲歷程，且需提出與身分證明文件相符之個人資料以供查驗，查詢費用每次為新台幣壹百捌捨元，由甲方負&nbsp;擔。乙方接獲甲方之查詢申請，應提供前述所列之甲方個人遊戲歷程，並於七日內以光碟或磁片等儲存媒介或書面、電子郵件方式提供資料。
              </p>
              <p>&nbsp;</p>
              <p>第九條&nbsp;甲方的義務</p>
              <p>
                1.&nbsp;甲方同意按照乙方不時發佈、變更和修改的本合約條款及其他規則接受並使用本服務，甲方不得通過不正當的手段或其他不公平的手段使用本服務或參與乙方活動。
              </p>
              <p>2.&nbsp;甲方不得干擾乙方正常地提供本服務，包括但不限於：</p>
              <p>（1）攻擊、侵入乙方的網站伺服器或使網站伺服器過載；</p>
              <p>（2）破解、修改乙方提供的客戶端程序；</p>
              <p>
                （3）攻擊、侵入乙方的遊戲伺服器或遊戲伺服器端程序或使遊戲伺服器過載；
              </p>
              <p>
                （4）製作、使用、發佈、傳播任何形式的妨礙遊戲公平性的輔助工具或程序（外掛）；
              </p>
              <p>
                （5）利用程序的漏洞和錯誤（Bug）破壞遊戲的正常進行或傳播該漏洞或錯誤（Bug）；
              </p>
              <p>（6）干擾或阻礙他人使用本服務。</p>
              <p>（7）違法蒐集他人之個人資料。</p>
              <p>（8）其他不符合法令規範之行為。</p>
              <p>
                3.&nbsp;甲方必須保管好自己的帳號和密碼，由於甲方的原因導致帳號和密碼洩漏而造成的後果均將由甲方自行承擔。
              </p>
              <p>
                4.&nbsp;甲方僅能以一個單獨的個人的身份使用本服務，甲方不能利用本服務從事商業目的的活動，也不能利用本服務進行銷售或其他商業目的的活動。
              </p>
              <p>
                5.&nbsp;甲方需對自己帳號中的所有活動和事件負責。甲方須遵守有關Internet訊息發佈的有關法律、法規及通常適用的Internet一般道德和禮儀的規範。
              </p>
              <p>
                6.&nbsp;甲方的遊戲帳號、遊戲角色，以及與乙方產品相關的論壇暱稱不得包含本協議二十二條第4項第5款所禁止發佈的內容。
              </p>
              <p>&nbsp;</p>
              <p>第十條&nbsp;隱私保護</p>
              <p>
                1.&nbsp;若法定代理人（如父母、監護人）希望未成年人（滿七歲但未滿二十歲）得以使用本服務，必須取得法定代理人之允許始得申請註冊﹔若甲方為無行為能力人（未滿&nbsp;七歲之未成年人），則請由甲方的法定代理人代為註冊申請。在接受本服務時，應以法定代理人身份加以判斷本服務是否適合於未成年人。乙方保證不對外公開或向&nbsp;第三方提供用戶註冊資料及用戶在使用網路服務時存儲在的非公開內容，但下列情況除外：
              </p>
              <p>（1）事先獲得用戶的明確授權；</p>
              <p>（2）根據有關的法律法規要求；</p>
              <p>（3）按照相關政府主管部門的要求；</p>
              <p>（4）為維護社會公眾的利益；</p>
              <p>
                2.&nbsp;乙方可能會與第三方合作向用戶提供相關的網路服務，在此情況下，如該第三方同意承擔與乙方同等的保護用戶隱私的責任，則乙方可將用戶的註冊資料等提供給該&nbsp;第三方。（注：目前並不存在该第三方，如有符合本條约定的第三方，乙方會根據實際情況向用户公開该第三方信息）
              </p>
              <p>
                3.&nbsp;在不透露單個用戶隱私資料的前提下，有權對整個用戶數據庫進行技術分析並對已進行分析、整理後的用戶數據庫進行商業上的利用。儘管對用戶的隱私權保護做了極大的努力，但是乙方仍然不能保證現有的安全技術措施使用戶的技術訊息等不受任何形式的損失。
              </p>
              <p>&nbsp;</p>
              <p>第十一條&nbsp;免責聲明</p>
              <p>1.&nbsp;乙方不保證以下事宜：</p>
              <p>（1）本服務將符合甲方的要求。</p>
              <p>（2）本服務將不受干擾、及時提供、安全可靠或不會出錯。</p>
              <p>
                （3）第三人藉由非法方式介入或侵害甲方之權利，但乙方受甲方告知有此情事發生時，乙方將協助甲方排除或協助查明侵害來源。
              </p>
              <p>
                2.&nbsp;甲方明確同意使用網路服務所存在的風險將完全由自己承擔；因使用網路服務而產生的一切後果也由自己承擔，乙方除因系統設備發生錯誤、畫面暫停、遲滯、中斷&nbsp;或不能進行連線而致不能提供甲方服務，或提供本服務時未維護其自身電腦系統符合當時科技或專業水準可合理期待之安全性、未採取合理措施儘速回復電腦系統遭&nbsp;受的破壞或運作異常、遊戲程式漏洞外，乙方對甲方不承擔任何其他責任。
              </p>
              <p>&nbsp;</p>
              <p>第十二條&nbsp;服務變更、中斷或終止</p>
              <p>
                1.&nbsp;乙方各項系統設備因預先計畫所需之系統維護停機，應於七日前於遊戲網站中公告，且於甲方登入時通知，並於遊戲進行中發佈停機訊息。
              </p>
              <p>
                2.&nbsp;乙方有權以書面或電子郵件通知後，暫停向甲方提供本協議項下的網路服務。
              </p>
              <p>
                3.&nbsp;除前項所述情形外，乙方同時保留以公告及電子信箱等方式通知甲方的情況下隨時中斷或終止部分或全部網路服務的權利。
              </p>
              <p>
                4.&nbsp;甲方同意如果在註冊通行證後的第一個月時間內或連續6個月時間內，沒有使用過此通行證(包括使用此通行證登入遊戲，登入網站，儲值)，則該通行證不會被系統保留。
              </p>
              <p>&nbsp;</p>
              <p>第十三條&nbsp;電磁記錄</p>
              <p>
                本遊戲之所有電磁記錄均屬乙方所有，乙方並應維持甲方相關電磁記錄之完整。甲方對於前項電磁記錄有支配之權利。
              </p>
              <p>&nbsp;</p>
              <p>第十四條&nbsp;網路遊戲中虛擬物品的約定</p>
              <p>
                遊戲中的各種虛擬物品不限於金幣、銀兩、道具、裝備等，其所有權歸乙方所有。甲方只能在合乎法律和遊戲規則的情況下擁有對虛擬物品的使用權。甲方同意就已使用於購買虛擬物品使用權之儲值，不得以任何理由要求退費。
              </p>
              <p>
                甲方不得自行與其他玩家進行線下交易，遊戲內的遊戲幣、道具、裝備等虛擬物品都是不允許線下交易的。若玩家自行線下交易出現任何問題或爭議，與乙方無關，玩家將自行負責。
              </p>
              <p>&nbsp;</p>
              <p>第十五條&nbsp;註銷角色</p>
              <p>
                在下列情況下，乙方可以註銷甲方創造的角色，並刪除該角色的所有記錄：
              </p>
              <p>
                1.&nbsp;甲方註冊的遊戲角色未達到一定遊戲要求，並且在該角色所關聯的遊戲分區中可用遊戲點數或遊戲時間為零的情況下，連續三十天未通過該角色登入過乙方的遊戲。
              </p>
              <p>
                2.&nbsp;甲方自行刪除的角色，自刪除之日起三十天內沒有恢復的。
              </p>
              <p>
                3.&nbsp;關於乙方所提供的不同產品中註銷角色的具體條件，以各個產品的具體規定，或提供本服務的相關官方網站上的具體規定為準。
              </p>
              <p>&nbsp;</p>
              <p>第十六條&nbsp;服務中斷、停止和變更的說明</p>
              <p>
                發生下列情形之一時，乙方有權中斷、停止或變更乙方提供的服務，
              </p>
              <p>
                1.&nbsp;乙方各項系統設備進行定期檢查或施工，軟硬體更新等，可提前7日於遊戲網站向玩家公告，且於甲方登入時通知、於遊戲進行中發佈停機訊息後暫停服務。
              </p>
              <p>2.&nbsp;伺服器遭到任何形式的破壞，無法正常運作。</p>
              <p>
                3.&nbsp;網路線路或其它導致玩家通過Internet連接至乙方伺服器的動作發生滯&nbsp;礙等情形。
              </p>
              <p>4.&nbsp;自然災害等不可抗力的因素。</p>
              <p>5.&nbsp;在緊急情況之下為維護其它會員及第三者人身安全時。</p>
              <p>6.&nbsp;發生突發性軟硬體設備與電子通信設備故障時。</p>
              <p>
                對於上述第2點至第6點原因而引起系統設備發生錯誤、遊戲畫面暫停、遲滯、中斷或遊戲不能進行連線等情形并對甲方造成虛擬貨幣或虛擬道具的損失，甲方可向乙方提出返還要求，乙方將根據甲方的實際損失情況返還相應的虛擬貨幣或虛擬道具。
              </p>
              <p>&nbsp;</p>
              <p>第十七條&nbsp;個人資料的轉移和遊戲方式的轉變</p>
              <p>
                乙方將盡力持續地向甲方提供本服務，但是乙方並不排除停止提供本服務的可能性，也不排除任何改變遊戲方式的可能性。如果乙方停止或改變提供本服務，乙&nbsp;方將會事先在遊戲相關網頁公告或以電子郵件通知甲方，並盡力尋找適當的服務提供者或方式以代替乙方繼續提供本服務。在這種情況下，乙方可能會將甲方的個人&nbsp;資料（包括有關的帳號和密碼訊息及個人資料）轉移給該繼續提供服務的一方，也可能需要永久封存原有資料以推行新的遊戲方式。
              </p>
              <p>
                如若甲方不同意乙方上述安排，應於變更訊息公告后15日內，以書面表示反對，則在本服務停止后30日內，乙方於扣除必要成本後以現金、信用卡、匯票或掛號寄發支票方式退還甲方未使用之儲值或遊戲費用。
              </p>
              <p>&nbsp;</p>
              <p>第十八條&nbsp;資費政策</p>
              <p>
                乙方有權決定乙方所提供的本服務的資費標準和收費方式，乙方可就不同的服務制定不同的資費標準和收費方式，也可按照乙方所提供的本服務的不同階段制定&nbsp;不同的資費標準和收費方式。另外，乙方也可不時地修改乙方的資費政策。乙方應將有關本服務的收費訊息以及與本服務有關的資費標準、收費方式、購買方式或其&nbsp;他有關資費政策的訊息放置在本服務相關網頁的顯著位置。如資費調整時，乙方將於預定調整生效日三十日前於本服務相關網頁上公告。
              </p>
              <p>
                對於乙方的收費本服務，甲方應該按照乙方確定的資費政策購買本服務。如果甲方未按乙方確定的資費政策購買本服務，乙方可以立即停止向甲方提供本服務。
              </p>
              <p>&nbsp;</p>
              <p>第十九條&nbsp;資訊公開</p>
              <p>乙方應於遊戲網站上提供本遊戲相關資訊，並定期更新。</p>
              <p>&nbsp;</p>
              <p>第二十條&nbsp;遊戲版本更新變動的說</p>
              <p>
                為增加並豐富遊戲的內容，遊戲在運行時會不定期更新並調整改變遊戲內所有的功能。在遊戲更新後，甲方同意一切遊戲內的操作、內容、設定將以遊戲中實際更新內容為準。
              </p>
              <p>&nbsp;</p>
              <p>第二十一條&nbsp;有限保證及責任限制</p>
              <p>
                對於本服務，乙方僅作下述有限保證，該有限保證取代任何文件、包裝、或其他資料中的任何其他明示或默示的保證（如果有）。乙方僅以“現有狀況且包含所有錯誤”的形式提供相關的產品、軟體或程序及任何支持服務，並僅保證：
              </p>
              <p>（1）乙方所提供的本服務能基本符合乙方正式公佈的要求；</p>
              <p>
                （2）乙方所提供的相關本服務基本與乙方正式公佈的服務承諾相符；
              </p>
              <p>
                乙方僅在商業上允許的合理範圍內盡力解決乙方在提供本服務過程中所遇到的任何問題。在適用法律允許的最大範圍內，乙方明確表示不提供任何其他類型的保&nbsp;證，不論是明示的或默示的，包括但不限於適銷性、適用性、可靠性、準確性、完整性、無病毒以無錯誤的任何默示保證和責任。另外，在適用法律允許的最大範圍&nbsp;內，乙方並不擔保所提供的本服務一定能滿足甲方的期待。
              </p>
              <p>
                在適用法律允許的最大範圍內，乙方不就因甲方使用本服務引起的，或在任何方面與本服務有關的任何意外的、非直接的、非常態性的、或間接的損害或請求&nbsp;（包括但不限於因人身傷害、因隱私洩漏、因未能履行包括誠信或合理謹慎在內的任何責任、因過失和因任何其他金錢上的損失或其他非金錢損失而造成的損害賠&nbsp;償）承擔任何責任。
              </p>
              <p>&nbsp;</p>
              <p>第二十二條&nbsp;遊戲管理</p>
              <p>
                1.資料轉移：在出現本公司遊戲伺服器合併情形時，本公司有權將用戶的角色檔案轉移到其它本公司遊戲伺服器。
              </p>
              <p>
                2.為規範遊戲進行之方式，乙方應訂立合理公平之遊戲管理規則，甲方應遵守乙方公告之遊戲管理規則。遊戲管理規則之變更應依第三十條之約定為之。
              </p>
              <p>3.遊戲管理規則有下列情形之一者，其規定無效：</p>
              <p>(1)抵觸線上遊戲定型化契約應記載及不得記載事項之規定。</p>
              <p>
                (2)剝奪或限制甲方之契約上權利。但乙方依下列第4項第7點對違反應遵守服務使用者守則之甲方進行處理，不在此限。
              </p>
              <p>4.甲方應遵守服務使用者守則</p>
              <p>
                (1)嚴禁修改、反譯或進行任何影響遊戲程序和遊戲網路數據傳輸封包的行為；
              </p>
              <p>
                (2)嚴禁使用任何方法對伺服器進行惡意入侵、攻擊，或任何破壞網路服務正常運行的行為；
              </p>
              <p>
                (3)禁止利用遊戲Bug和第三方外掛程式進行賺取金錢、複製裝備、快速累積經驗值等破壞遊戲公平性及造成伺服器負擔加重的行為；
              </p>
              <p>
                (4)禁止公開或私下傳播任何存在並可利用的遊戲Bug，請在發現該類問題時立即向乙方反應；
              </p>
              <p>
                (5)禁止使用含有人身攻擊、淫穢、辱罵、反動及其他危害本遊戲形象、同GM角色名故意相似擾亂正常服務秩序以及違反社會善良風氣的角色名；
              </p>
              <p>
                (6)禁止使用公共頻道惡意刷屏，或做出任何影響正常遊戲秩序的行為；
              </p>
              <p>
                (7)任何違反以上條款的違規行為，GM有權根據情節輕重對違規者進行警告、強制下線、禁閉、更名、刪除人物或凍結帳號的處罰，情節尤其嚴重者，將進一步追究法律責任，違規造成的一切損害或損失，由甲方自行承擔；
              </p>
              <p>
                (8)除本契約另有規定外，有事實足證甲方於本遊戲中違反遊戲管理規則時，乙方應於遊戲網站或遊戲進行中公告，並以線上即時通訊方式或電子郵件通知甲方。經乙方通知改善而未改善者，乙方得依遊戲管理規則，按其情節輕重限制甲方之遊戲使用權利；
              </p>
              <p>
                (9)乙方依遊戲管理規則停止甲方進行遊戲之權利，每次不得超過七日；
              </p>
              <p>
                (10)除構成第25條契約終止事由外，乙方依遊戲管理規則對甲方所為之處置，不得影響甲方依本契約應享之權利。
              </p>
              <p>&nbsp;</p>
              <p>第二十三條&nbsp;合約之變更</p>
              <p>
                1.&nbsp;乙方修改本契約時，應於遊戲網站首頁及遊戲之登入頁面公告之，並以書面或電子郵件通知甲方。
              </p>
              <p>2.&nbsp;乙方未依前項進行公告及通知者，其契約之變更無效。</p>
              <p>3.&nbsp;甲方於第一項通知到達後十五日內：</p>
              <p>(1)甲方未為反對之表示者，視為甲方接受乙方契約變更之內容。</p>
              <p>(2)甲方為反對之表示者，視為甲方對乙方終止本契約之通知。</p>
              <p>&nbsp;</p>
              <p>第二十四條&nbsp;合約之終止及退費</p>
              <p>1.&nbsp;甲方得隨時以書面或電子郵件通知乙方終止本契約。</p>
              <p>
                2.&nbsp;甲方於遊戲網站或遊戲內消費後，遲延支付款項者，乙方將於通知後暫停甲方遊戲權限。
              </p>
              <p>
                3.&nbsp;本契約終止時，乙方於扣除必要成本及贈送甲方之點數後，應於甲方完成退費申請程序後三十日內，以現金、信用卡、匯票或掛號寄發支票方式退還甲方未使用之儲&nbsp;值。因乙方販售其點數卡或其他各種通路需支出一定比例通路成本，此部分視為乙方必要成本，故甲方申請退費時將扣除３０％必要成本。
              </p>
              <p>
                4.&nbsp;甲方有下列重大情事之一者，乙方以書面或電子郵件通知甲方後，得立即終止本契約：
              </p>
              <p>(1)&nbsp;利用任何系統或工具對乙方電腦系統之惡意攻擊或破壞。</p>
              <p>
                (2)&nbsp;以利用外掛程式、病毒程式、遊戲程式漏洞或其他違反公平合理之方式進行遊戲。
              </p>
              <p>
                (3)&nbsp;乙方依第二項暫停甲方遊戲權限後三十日內，甲方仍未支付款項。
              </p>
              <p>(4)&nbsp;經司法機關查獲從事任何不法之行為。</p>
              <p>
                乙方對前項事實認定產生錯誤或無法舉證時，乙方應對甲方之損害負賠償責任。
              </p>
              <p>&nbsp;</p>
              <p>第二十五條&nbsp;過期帳號刪除管理</p>
              <p>
                甲方登錄之帳號超過一年（含）未登入遊戲網站及未使用本服務，且帳號未含有未使用點數，乙方應公告並以書面或電子郵件方式通知甲方，甲方於通知後三十天內無登入網站及使用服務者，乙方得刪除該帳號，並回收相關虛擬遊戲套件。
              </p>
              <p>&nbsp;</p>
              <p>第二十六條&nbsp;送達</p>
              <p>
                1.&nbsp;有關本契約所有事項之通知，甲方同意乙方以甲方登錄之聯絡地址或電子郵件地址為送達。
              </p>
              <p>
                2.&nbsp;前項登錄地址若有變更，甲方應即通知乙方。乙方應依變更後之地址為
              </p>
              <p>
                3.&nbsp;乙方依本條地址所為之通知發出後，以書面通知到達甲方，或電子郵件進入甲方之電子郵件伺服器中，推定為已送達。
              </p>
              <p>
                4.&nbsp;因甲方之故意或過失致乙方無法為送達者，乙方對甲方因無法送達所致之損害不負賠償責任。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <!-- <p>香港鈴六網絡科技有限公司</p>
            <p>Guangzhou Lulin Technology Co. LTD</p>
            <p>广州市天河区棠下荷光三横路13号301房</p> -->
      <div>
        <p>※本軟體因涉及暴力、打鬥，依遊戲軟體分級管理辦法分類為輔12級</p>
        <p>※遊戲內提供購買虛擬遊戲幣、物品等付費服務</p>
        <p>※請注意遊戲時間，避免沉迷</p>
        <p>※Lingluk Game</p>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../../public/js/jquery.min.js'

export default {
  mounted() {
    $('#focus .imgs ul').width(
      $('#focus .imgs li').length * $('#focus').width()
    )
    $('#focus .ctrl a:eq(0)').addClass('on')
    var focusT

    function focus() {
      focusT = setInterval(function () {
        var i = $('#focus .ctrl a.on').index('#focus .ctrl a') || 0,
          l = $('#focus .ctrl a').length
        i++
        if (i > l - 1) i = 0
        $('#focus .ctrl a').removeClass('on').eq(i).addClass('on')
        $('#focus .imgs ul')
          .stop(true, true)
          .animate(
            {
              left: -$('#focus').width() * i
            },
            600
          )
      }, 8000)
    }
    focus()
    //幻灯
    $('#focus .ctrl a').click(function () {
      clearInterval(focusT)
      var i = $(this).index('#focus .ctrl a')
      $('#focus .ctrl a').removeClass('on').eq(i).addClass('on')
      $('#focus .imgs ul')
        .stop(true, true)
        .animate(
          {
            left: -$('#focus').width() * i
          },
          600,
          function () {
            focus()
          }
        )
    })

    $('.sectionC .next,.sectionC .prev').click(function () {
      var i = $('.sectionC .ctrl a.on').index() || 0,
        l = $('.sectionC .ctrl a').length
      if ($(this).hasClass('next')) {
        i++
        if (i > l - 1) i = 0
      } else {
        i--
        if (i < 0) i = l - 1
      }
      $('.sectionC .ctrl a').removeClass('on').eq(i).addClass('on')
      $('.sectionC .imgs li').removeClass('on').eq(i).addClass('on')
    })
    //特色
    $('.sectionC .ctrl a').click(function () {
      var i = $(this).index()
      $('.sectionC .ctrl a').removeClass('on').eq(i).addClass('on')
      $('.sectionC .imgs li').removeClass('on').eq(i).addClass('on')
    })
    //场景
    $('#scene .ctrl a').click(function () {
      var i = $(this).index('#scene .ctrl a')
      $('#scene .ctrl a').removeClass('on').eq(i).addClass('on')
      $('#scene .imgs li').hide().eq(i).fadeIn(800)
    })
    $('.sider a').click(function () {
      var i = $(this).index()
      if (i < 4) {
        $('html,body').animate(
          {
            scrollTop: $('.section').eq(i).offset().top
          },
          500
        )
      }
    })

    function play_image_list(elementID, effect, play_time) {
      var _div = $('.' + elementID + ' ul')
      var temp_time
      if (_div.children('li').length <= 4) {
        return false
      }
      //play_img("left");
      _div.width(
        _div.children('li').length * (_div.children('li').eq(0).width() + 20)
      )
      if (effect === 'continue') {
        play_time = 30
        _div.css('margin-left', '0px')
      }
      temp_time = setTimeout(function () {
        play_img('left')
      }, play_time)
      _div.parent().hover(
        function () {
          clearTimeout(temp_time)
        },
        function () {
          temp_time = setTimeout(function () {
            play_img('left')
          }, play_time)
        }
      )

      function play_img(type) {
        if (temp_time) {
          clearTimeout(temp_time)
        }
        var div_f = $('.' + elementID + ' ul>li:first'),
          div_l = $('.' + elementID + ' ul>li:last'),
          div_width = div_f.width()
        //alert(div_width);
        if (effect === 'continue') {
          play_time = 30
          var num =
            _div[0].style.marginLeft == '0px'
              ? parseInt(_div[0].style.marginLeft)
              : parseInt(_div[0].style.marginLeft.substring(1))
          num++
          if (num <= div_width + 20) {
            _div.css('margin-left', -num + 'px')
          } else {
            _div.append(div_f)
            _div.css('margin-left', '0px')
          }
        }
        temp_time = setTimeout(function () {
          play_img('left')
        }, play_time)
        return false
      }
    }

    function minWidth() {
      var isIE6 = !-[1] && !window.XMLHttpRequest
      //if(!isIE6){return false;}
      var num = 980
      var w_width = $(window).width()
      if (w_width > num) {
        $('body').width('100%')
      } else {
        $('body').width(980)
      }
    }
    play_image_list('logs', 'continue', 4000)
    var my_jPlayer

    function scrollTxt() {
      var controls = {},
        values = {},
        t1 = 300,
        /*播放动画的时间*/
        t2 = 4000,
        /*播放时间间隔*/
        si
      controls.rollWrap = $('#roll-wrap')
      controls.rollWrapUl = controls.rollWrap.children()
      controls.rollWrapLIs = controls.rollWrapUl.children()
      values.liNums = controls.rollWrapLIs.length
      values.liHeight = controls.rollWrapLIs.eq(0).height()
      values.ulHeight = controls.rollWrap.height()
      this.init = function () {
        autoPlay()
        pausePlay()
      }
      /*滚动*/
      function play() {
        controls.rollWrapUl.animate(
          {
            'margin-top': '-' + values.liHeight
          },
          t1,
          function () {
            $(this).css('margin-top', '0').children().eq(0).appendTo($(this))
          }
        )
      }

      /*自动滚动*/
      function autoPlay() {
        /*如果所有li标签的高度和大于.roll-wrap的高度则滚动*/
        if (values.liHeight * values.liNums > values.ulHeight) {
          si = setInterval(function () {
            play()
          }, t2)
        }
      }

      /*鼠标经过ul时暂停滚动*/
      function pausePlay() {
        controls.rollWrapUl.on({
          mouseenter: function () {
            clearInterval(si)
          },
          mouseleave: function () {
            autoPlay()
          }
        })
      }
    }
    new scrollTxt().init()
  }
}
</script>

<style lang='scss' scoped src='../../../../public/css/home1.css'></style>
<style lang='scss' scoped src='../../../../public/css/copy.css'></style>
<style lang='scss' scoped src='../../../../public/css/black.css'></style>
<style lang="scss" scoped>
.footer p {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/route/src/lingliu/terms/index.vue